import { render, staticRenderFns } from "./yi-mescroll-uni.vue?vue&type=template&id=57f190db&"
import script from "./yi-mescroll-uni.vue?vue&type=script&lang=js&"
export * from "./yi-mescroll-uni.vue?vue&type=script&lang=js&"
import style0 from "./yi-mescroll-uni.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "src/components/yi-mescroll-uni/yi-mescroll-uni.vue"
export default component.exports